import { createStore, compose, applyMiddleware } from 'redux'
import { routerMiddleware } from 'react-router-redux'
import thunk from 'redux-thunk'

import reducer from './reducer'
import { tokenRefreshMiddleware, externalUserMiddleware } from './auth'

export default function configureStore (history, initialState = {}) {
  const middleware = compose(
    applyMiddleware(
      routerMiddleware(history),
      externalUserMiddleware,
      tokenRefreshMiddleware,
      thunk
    ),
    window.devToolsExtension ? window.devToolsExtension() : f => f
  )

  const store = createStore(reducer, initialState, middleware)

  // Not currently working for some reason
  // https://github.com/gaearon/react-hot-boilerplate/pull/61#issuecomment-216269339
  if (module.hot) {
    module.hot.accept('./auth', () => {
      store.replaceReducer(require('./reducer').default)
      return true
    })
  }

  return store
}



// WEBPACK FOOTER //
// ./src/redux/store.js